import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "../../components/Dialog";
import { socketErrorMessage } from "store/knowledge-base-item/knowledge-base-item.actions";
import { getUnavailableEntityBackRoute } from "store/knowledge-base-item/knowledge-base-item.utils";
import { getKnowledgeBaseItemState, socketErrorSelector, } from "store/knowledge-base-item/knowledge-base-item.selectors";
import { GlobalEntityType } from "shared/types";
import { DIALOG_ACTION_TITLE } from "shared/labels";
import { ErrorType } from "api/api-error";
import { navigate } from "shared/navigation";
import * as styles from "./styles.module.scss";
export const TimeoutErrorTemplate = {
    propertyName: "session",
    text: "Timeout",
    errorType: ErrorType.Forbidden,
};
const TimeoutDialog = () => {
    const dispatch = useDispatch();
    const { entityType, name } = useSelector(getKnowledgeBaseItemState);
    const socketError = useSelector(socketErrorSelector);
    const isOpen = useMemo(() => {
        if (socketError === null) {
            return false;
        }
        return socketError.errors.some(({ propertyName, errorType }) => propertyName === TimeoutErrorTemplate.propertyName && errorType === TimeoutErrorTemplate.errorType);
    }, [socketError]);
    const type = useMemo(() => {
        switch (entityType) {
            case GlobalEntityType.CellModel:
                return "Cell Model";
            case GlobalEntityType.Recipe:
                return "Recipe";
            case GlobalEntityType.RsWorkspace:
                return "Workspace";
        }
    }, [entityType]);
    const handleCancel = useCallback(() => {
        dispatch(socketErrorMessage(null));
        navigate(getUnavailableEntityBackRoute(entityType));
    }, [dispatch, entityType]);
    const handleOk = useCallback(() => {
        dispatch(socketErrorMessage(null));
        window.location.reload();
    }, [dispatch]);
    return (React.createElement(Dialog, { isOpen: isOpen, title: "Session has expired", secondaryButtons: [{ onClick: handleCancel, label: DIALOG_ACTION_TITLE.CANCEL }], primaryButton: { onClick: handleOk, label: DIALOG_ACTION_TITLE.OK } },
        React.createElement("div", { className: styles.info }, `Your session has expired. Would you like to open ${name} ${type} in Edit mode to continue your work?`)));
};
export default TimeoutDialog;
